import React from 'react';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Stop from '@material-ui/icons/Stop';
import Refresh from '@material-ui/icons/Refresh';
import { ActionMenu } from '../../ActionMenu';
import {
  GCPActionMenuItems,
  GcpVmAction,
  GCPActionType,
  GCPResourceType,
} from './types';

interface GcpMenuProps {
  handleActionClick: (action: GCPActionType, service: GCPResourceType) => void;
  handleMenuClose: () => void;
  handleOpenConnection: () => void;
  menuPosition: { mouseX: number | null; mouseY: number | null };
  service: GCPResourceType;
}

const getMenuItems = (service: GCPResourceType): GCPActionMenuItems[] => {
  switch (service) {
    case 'vm': {
      return [
        {
          action: GcpVmAction.START,
          service: 'vm',
          icon: <PlayArrow fontSize="small" color="primary" />,
          text: 'Start GCP VMs',
          disabled: false,
        },
        {
          action: GcpVmAction.STOP,
          service: 'vm',
          icon: <Stop fontSize="small" color="secondary" />,
          text: 'Stop GCP VMs',
          disabled: false,
        },
        {
          action: GcpVmAction.RESTART,
          service: 'vm',
          icon: <Refresh fontSize="small" color="primary" />,
          text: 'Restart GCP VMs',
          disabled: false,
        },
      ];
    }
    default:
      return [];
  }
};

export const GcpActionMenu: React.FC<GcpMenuProps> = ({
  handleActionClick,
  handleMenuClose,
  menuPosition,
  service,
}) => {
  const menuItems = getMenuItems(service);

  return (
    <ActionMenu<{
      action: GCPActionType;
      service: GCPResourceType;
    }>
      handleActionClick={handleActionClick}
      handleMenuClose={handleMenuClose}
      menuPosition={menuPosition}
      menuItems={menuItems}
    />
  );
};
